/**
 * Noop validation in production
 * @private
 */
function noop() {
	return () => true;
}

export default noop;
